module.exports = __webpack_public_path__ + "img/put-chart.0d958bef.svg";